import React, { useEffect, useState } from 'react'
import api from '../components/api'
import axios from 'axios'
import ModalFoto from '../modals/foto.js'

const Fotos = (props) => {


    const evento_id = props.evento_id
    const linkAPI = props.linkAPI
    const ad_usr = sessionStorage.getItem('us_codigo')

    var [imagem, setImagem] = useState()
    var [file, setFile] = useState('')
    var [legenda, setLegenda] = useState('')
    var [ordem, setOrdem] = useState('')
   

    var [fotos, setFotos] = useState()
    var [eventoFoto_id, setEventoFotoId] = useState()


    function uploadFoto() {

        if (file == '') {

            window.toastr.error('Por favor, selecione uma imagem!')
            return false

        }

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    

                    const formData = new FormData();
                    const imagefile = document.querySelector("#fileImgFoto");

                    

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("imagemEvento", imagefile.files[0]);
                    formData.append("legenda", legenda); // string junto ao formData.
                    formData.append("ad_usr", ad_usr); // string junto ao formData.
                    formData.append("ordem", ordem)
                    
                    //console.log('altera')
                    //return false

                    axios.post(`${linkAPI}/eventoFoto/${evento_id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-access-token': '!nf0$@ud#2',
                    }
                    }).then(response => {

                        // console.log(response.data)
                        //setImagem(response.data.imagem)
                        //setFile('')

                        if (response.data.alerta == 'ok') {

                            window.toastr.success('Salvo com sucesso!')
                            setLegenda('')
                            setFile('')
                            carregaFotos()
                            props.totalizaFotosEvento()


                        } else {

                            window.toastr.error('Ocorreu um erro ao salvar, por favor contacte o administrador do sistema')
                            return false

                        }

                        

                    }).catch((err) => {

                        console.log(err.response)

                    })


                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    function carregaFotos() {


        api.get(`eventoFotos/${evento_id}`).then((result) => {

            //console.log(result.data)
            setFotos(result.data.map((rs) =>
            
                <div style={{ display: 'inline-block', padding: '5px'}}>
                    <img src={`${linkAPI}/uploads/fotosEventos/${rs.arquivo}`} style={{ width: '200px', cursor: 'pointer'}} data-toggle="modal" data-target="#modalFoto" onClick={() => setEventoFotoId(rs.eventoFoto_id)} />
                </div>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }


    useEffect(() => {

        carregaFotos()


    }, [])


    return (

        <div class="panel-body">
                                
                                

            
            <div class="col-md-12">
                <div class="form-group">
                    <label>Upload foto</label>
                    <input type="file" className="form-control" id="fileImgFoto" value={file} onChange={event => setFile(event.target.value)} />
                                    
                </div>
            </div>
            <div class="col-md-7">
                <div class="form-group">
                    <label>Legenda</label>
                    <input type="text" className="form-control" value={legenda} onChange={event => setLegenda(event.target.value)} maxLength="1000"/>
                                    
                </div>
            </div>
            <div class="col-md-5">
                <div class="form-group">
                    <label>Ordem</label>
                    <input type="text" className="form-control" value={ordem} placeholder='Deixar em branco para ordenar por ordem de upload' 
                    pattern="[0-9]*" 
                    onChange={(e) =>
                        setOrdem((v) => (e.target.validity.valid ? e.target.value : v))
                    }
                    />
                                    
                </div>
            </div>
            <div class="col-md-12">

                
                <button type="button" class="btn btn-warning" onClick={() => uploadFoto()}>Upload foto</button>

                <br/>
                <br/>
            </div>


            <div class="col-md-12">
                
                    
                    {fotos}
                                    
                
            </div>



            <ModalFoto eventoFoto_id={eventoFoto_id} carregaFotos={carregaFotos} linkAPI={linkAPI} totalizaFotosEvento={props.totalizaFotosEvento} />

            
        </div>


    )



}


export default Fotos